import { CheckmarkCircleFilled, CrossCircle, MinusCircleFilled } from '@creditornot/cb-icons';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import { SupportableReportMetric } from './types';

export type MetricsDetailsProps = {
  supportedMetrics: SupportableReportMetric[];
  selectedMetrics: string[];
  action?: ReactNode;
};

const MetricsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding-block: 16px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;

const MetricContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const MetricHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledCheckIcon = styled(CheckmarkCircleFilled)`
  fill: ${colors.lime100};
  width: 12px;
  height: 12px;
`;

const StyledCrossIcon = styled(CrossCircle)`
  fill: ${cbSemanticCssVars.textSecondary};
  width: 12px;
  height: 12px;
`;

const StyledMinusIcon = styled(MinusCircleFilled)`
  fill: ${cbSemanticCssVars.textSecondary};
  width: 12px;
  height: 12px;
`;

const MetricDescription = styled(Typography.Body3)`
  display: flex;
  padding-inline: 20px;
  align-items: flex-start;
  gap: 8px;
  color: ${cbSemanticCssVars.textSecondary};
`;

export const MetricsDetails = ({ supportedMetrics, selectedMetrics }: MetricsDetailsProps) => {
  return (
    <MetricsContainer>
      {supportedMetrics.map(metric => (
        <MetricContainer key={metric.id}>
          <MetricHeader>
            {!metric.isSupported ? (
              <StyledMinusIcon />
            ) : selectedMetrics.includes(metric.id) ? (
              <StyledCheckIcon />
            ) : (
              <StyledCrossIcon />
            )}
            <Typography.Body3>{metric.name}</Typography.Body3>
          </MetricHeader>
          {/* TODO: @navjotahuja92 no metric description, hold this part until API is ready */}
          {false && (
            <MetricDescription>
              <Typography.Body3></Typography.Body3>
            </MetricDescription>
          )}
        </MetricContainer>
      ))}
    </MetricsContainer>
  );
};
